import React from "react";
import type { TreeNode } from "../../TreeView/types";

interface SidebarProps {
    nodes: TreeNode[];
    onNavigateToKnownLocation: (node: TreeNode) => void;
}

export const Sidebar: React.FC<SidebarProps> = ({ nodes, onNavigateToKnownLocation }) => {
    return (
        <div className="w-64 bg-white border-r overflow-y-auto">
            {nodes.map((node) => (
                <div key={node.id}>
                    <div
                        className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                        onClick={(e) => {
                            e.stopPropagation();
                            onNavigateToKnownLocation(node);
                        }}>
                        <span className="mr-2">{node.icon}</span>
                        <span className="text-sm">{node.label}</span>
                    </div>
                    {node.children && node.children.length > 0 && (
                        <div className="ml-4">
                            {node.children.map((child) => (
                                <div
                                    key={child.id}
                                    className="flex items-center p-2 hover:bg-gray-100 cursor-pointer"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onNavigateToKnownLocation(child);
                                    }}>
                                    <span className="mr-2">{child.icon}</span>
                                    <span className="text-sm">{child.label}</span>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};
